/**
 * TrackSuccess
 * 
 * @Author: Focci
 * @Date: 2023-08-17 14:35:31
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-17 14:35:31
 */

import PropTypes from 'prop-types'
import { useTranslations } from 'next-intl'
import { ButtonBase } from '@comp/material'
import TrackTitle from './TrackTitle'
import TrackProperty from './TrackProperty'
import TackAction from './track-form/TackAction'

export default function TrackSuccess({
  param,
  hideViewButton,
  onSubmit = () => {},
  property = {}
}) {
  const tt = useTranslations('track')
  
  return (
    <div>
      <TrackTitle label={tt('claimSuccess')} />
      <div className="max-w-[25rem] mx-auto">
        <div className="text-f.8 my-6 text-center">
          {tt('successfullyTracked')}
        </div>
        <TrackProperty data={property} />

        {param?.trackType === 6 && (
          <div className="my-8">
            <ButtonBase 
              className="w-full"
              onClick={() => onSubmit({ nextStep: 'edit' })}
            >
              <div 
                className="
                  text-center bg-primary/10 text-primary border border-primary/60
                  rounded-sm p-[.5rem] w-full
                "
              >
                {tt('updatePropertyIfError')}
              </div>
            </ButtonBase>
          </div>
        )}
      </div>
      <TackAction 
        property={property} 
        hideViewButton={hideViewButton} 
      />
    </div>
  )
}

TrackSuccess.propTypes = {
  onSubmit: PropTypes.func,
  property: PropTypes.object,
}
